import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { SidebarProvider, useSidebar } from '#AdminPanelFrontend/authorized/contexts/SidebarContext';

const Layout: React.FC = () => {
	return (
		<SidebarProvider>
			<LayoutContent />
		</SidebarProvider>
	);
};

const LayoutContent: React.FC = () => {
	const { isOpen, toggleSidebar } = useSidebar();

	return (
		<div className="flex bg-gray-100 dark:bg-gray-900 md:overflow-hidden h-full min-h-screen">
			<Sidebar isOpen={isOpen} />
			<div className={`flex flex-col flex-1 transition-all duration-300 ${isOpen ? 'ml-64 lg:ml-72' : 'ml-0'}`}>
				<TopBar toggleSidebar={toggleSidebar} />
				<main className="flex-1 md:overflow-x-hidden overflow-y-hidden bg-gray-100 dark:bg-gray-900 p-4 md:p-6 lg:p-8">
					<div className="max-w-7xl mx-auto">
						<Outlet />
					</div>
				</main>
			</div>
		</div>
	);
};

export default Layout;
